// Backend missing-key messages -> friendly text and the Settings card to open.
// The exact backend strings are pinned in lead-buyer-backend/tests/test_setup_error_strings.py:
// reword one there and you must update SETUP_ERROR_SAMPLES and the regexes below (and the reverse).
const SETUP_ERRORS = [
  { re: /resend api key (is missing|not configured)/i, text: 'Add your Resend API key in Settings to send email.', link: '/settings#resend' },
  { re: /sendgrid api key is missing/i, text: 'Add your SendGrid API key in Settings to send email.', link: '/settings#sendgrid' },
  { re: /smtp (not configured|(server|port|username|password) is not configured)/i, text: 'Finish your SMTP settings (server, port, username and password) in Settings.', link: '/settings#smtp' },
  { re: /sender email (is missing|not configured|is not configured)/i, text: 'Choose the address your emails come from in Settings.', link: '/settings#sender' },
  { re: /twilio (not configured|credentials (are not fully configured|not configured))/i, text: 'Add your Twilio Account SID, Auth Token and phone number in Settings to send SMS.', link: '/settings#twilio' },
  { re: /\bai key (is )?not configured/i, text: 'Add your OpenRouter API key in Settings to use the AI features.', link: '/settings#ai' },
  { re: /scaleserp api key not configured|search is temporarily unavailable/i, text: 'Search is temporarily unavailable, please contact support.', link: null },
];

// The exact backend strings (as pinned by the backend test), with the Settings card each opens.
// The last one is the old search worker message, kept until every worker is redeployed.
export const SETUP_ERROR_SAMPLES = [
  ['SMTP not configured. Please add SMTP settings in Settings page.', '/settings#smtp'],
  ['SendGrid API key is missing. Please add your SendGrid API key in Settings page.', '/settings#sendgrid'],
  ['Sender email is missing. Please configure sender email in Settings page.', '/settings#sender'],
  ['Resend API key is missing. Please add your Resend API key in Settings page.', '/settings#resend'],
  ['Twilio not configured. Please add Twilio credentials in Settings page.', '/settings#twilio'],
  ['Resend API key not configured', '/settings#resend'],
  ['Twilio credentials not configured', '/settings#twilio'],
  ['AI key not configured. Please add it in Settings.', '/settings#ai'],
  ['SendGrid API key is missing. Please add it in Settings.', '/settings#sendgrid'],
  ['Sender email not configured in your settings. Please add a SENDER_EMAIL in Settings.', '/settings#sender'],
  ['Resend API key is missing. Please add it in Settings.', '/settings#resend'],
  ['SMTP server is not configured', '/settings#smtp'],
  ['SMTP port is not configured', '/settings#smtp'],
  ['SMTP username is not configured', '/settings#smtp'],
  ['SMTP password is not configured', '/settings#smtp'],
  ['Sender email is not configured', '/settings#sender'],
  ['AI key is not configured. Please add it in Settings.', '/settings#ai'],
  ['Twilio credentials are not fully configured. Please add Account SID and Auth Token in Settings.', '/settings#twilio'],
  ['Search is temporarily unavailable. Please contact support.', null],
  ['ScaleSerp API key not configured. Please add it in Settings.', null],
];

export function mapSetupError(message) {
  if (typeof message !== 'string' || !message) return null;
  const hit = SETUP_ERRORS.find((e) => e.re.test(message));
  if (!hit) return null;
  // Text before the matched part (e.g. "Failed to send test message 2: ") is kept by the caller
  const match = message.match(hit.re);
  const prefix = message.slice(0, match.index).trimStart();
  return { text: hit.text, link: hit.link, prefix };
}
